// extracted by mini-css-extract-plugin
export default {"header":"mobile_header_header__IxLIE","shopName":"mobile_header_shopName__lUiDw","menuStart":"mobile_header_menuStart__NEkPV"};